import { css } from '@emotion/react';
import t from 'react-translate';
import { config } from '@config/pendo.config.json';
import NvIcon from 'shared/components/nv-icon';
import { primary } from 'styles/global_defaults/colors';
import { semiBoldFontWeight } from 'styles/global_defaults/fonts';
import { standardSpacing } from 'styles/global_defaults/scaffolding';

type AddActionItemLinkProps = {
  className?: string;
  setShowAddRow: (show: boolean) => void;
};

const linkStyles = css`
  grid-column: 1 / -1;
  padding: ${standardSpacing}px 0 !important;
  font-weight: ${semiBoldFontWeight};
  color: ${primary} !important;
`;

const AddActionItemLink = ({ className, setShowAddRow }: AddActionItemLinkProps) => {
  const translationBase = t.MENTORING_PROGRAMS.GUIDANCE.ACTION_ITEMS;
  return (
    <div className={className}>
      <button
        type='button'
        css={linkStyles}
        className='btn btn-link d-flex align-items-center'
        onClick={() => setShowAddRow(true)}
        data-qa={config.pendo.athena.mentorshipProgram.preAssignedActionItems.addActionItemLink}
      >
        <NvIcon icon='add' size='smallest' className='mr-1' />
        {translationBase.ADD_ACTION_ITEM()}
      </button>
    </div>
  );
};

export default AddActionItemLink;
